/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useCallback } from "react";

import { TItem } from "../types";
import "../styles.scss";

interface IOptionsProps {
  onChange: (item: TItem) => void;
  item: TItem;
  isSelected: boolean;
}

const Option: React.FC<IOptionsProps> = ({ item, onChange, isSelected }) => {
  const onClickCallback = useCallback(() => {
    onChange(item);
  }, [onChange, item]);
  return (
    <div onClick={onClickCallback} className={isSelected ? "selected" : ""}>
      {item.value}
    </div>
  );
};

export default Option;
